<template>
	<div class="jiedaiOrder">
		<div class="radioBox">
			<el-radio-group v-model="radio" @change="changeRadio">
				<el-radio :label="0">全部</el-radio>
				<!-- <el-radio :label="6">待结算</el-radio> -->
				<el-radio :label="1">待完成</el-radio>
				<el-radio :label="2">已完成</el-radio>
				<!-- <el-radio :label="9">已取消</el-radio> -->
			</el-radio-group>
		</div>
		<el-table :data="tableData" height="100%" style="width: 100%;">
			<el-table-column label="状态" width="70">
				<template slot-scope="scope">
					<span v-if="scope.row.isPay===false" style="color:red;">待支付</span>
					<span v-else>
						{{scope.row.status===1?'进行中':'已完成'}}
					</span>
				</template>
			</el-table-column>
			<el-table-column label="创建时间" width="135">
				<template slot-scope="scope">
					{{$public.FTime(scope.row.createTime,'YYYY-MM-DD HH:mm')}}
				</template>
			</el-table-column>
			<el-table-column label="顾客">
				<template slot-scope="scope">
					{{scope.row.memberName}}
				</template>
			</el-table-column>
			<el-table-column label="项目" width="280">
				<template slot-scope="scope">
					<div v-for="(item,index) in scope.row.goodsNames" :key="item+index">
						{{item}}
					</div>
				</template>
			</el-table-column>
			<el-table-column label="宠物">
				<template slot-scope="scope">
					<div v-for="(item,index) in scope.row.petNames" :key="item+index">
						{{item}}
					</div>
				</template>
			</el-table-column>
			<el-table-column label="总计" width="90">
				<template slot-scope="scope">
					{{scope.row.totalMoney}}
				</template>
			</el-table-column>
			<el-table-column label="单号" width="110">
				<template slot-scope="scope">
					<span>{{scope.row.washRecordId}}</span>
				</template>
			</el-table-column>
			<el-table-column label="操作" width="120">
				<template slot-scope="scope">
					<el-button type="text" @click="see(scope.row)" style="margin-right: 5px;">查看</el-button>
					<span v-if="scope.row.isPay===false">
						<el-button v-if="scope.row.isPay===false" type="text" @click="cancel(scope.row)">取消</el-button>
					</span>
					<span v-else>
						<el-button v-if="scope.row.status===1" type="text" @click="complete(scope.row)">完成</el-button>
					</span>
				</template>
			</el-table-column>
		</el-table>
		<div class="pageBox">
			<page :page="page.page" :pageSize="page.pageSize" :total="page.total" @change="changePage"></page>
		</div>
		<!-- 结算 -->
		<div v-if="dialogSettlementState">
			<dialogSettlement :orderId="curOrder._id" @submit="dialogSettlementSubmit"></dialogSettlement>
		</div>
		<ximeiSee v-if="drawerJiyangPetSee_state" :curItem="curItem" @submit="submit_drawerJiyangPetSee"></ximeiSee>
		<!-- 备注弹窗 -->
		<div v-if="drawerXimeiComplete_state">
			<drawerXimeiComplete :curItem="curItem" @submit="submit_XimeiComplete"></drawerXimeiComplete>
		</div>
	</div>
</template>
<script>
	import page from "../../../../../components/page.vue"
	import dialogSettlement from "../../../../../components/dialog_settlement.vue"
	import ximeiSee from "../../drawer/ximeiSee.vue"
	import drawerXimeiComplete from "../../drawer/ximeiComplete.vue"
	export default {
		components:{page,dialogSettlement,ximeiSee,drawerXimeiComplete},
		data(){
			return{
				radio:0,
				tableData:[],
				page:{
					page:1,
					pageSize:10,
					total:0
				},
				// see
				drawerJiyangPetSee_state:false,
				curItem:{},
				// 结算
				dialogSettlementState: false,
				curOrder: {},
				// 完成弹窗
				drawerXimeiComplete_state:false,
			}
		},
		computed:{
			curShopId(){
				return this.$store.state.shopId;
			},
		},
		mounted(){
			this.getTableData();
		},
		methods: {
			// changeRadio
			changeRadio(){
				this.page.page=1;
				this.getTableData();
			},
			see(row){
				this.drawerJiyangPetSee_state = true;
				this.curItem = row;
			},
			submit_drawerJiyangPetSee(){
				this.drawerJiyangPetSee_state = false;
				this.getTableData();
			},
			// 结算
			pay(row) {
				this.curOrder = row
				this.dialogSettlementState = true;
			},
			dialogSettlementSubmit(a) {
				this.dialogSettlementState = false;
				if (a == 'close') {
					console.log(a)
				} else if (a == 'fail') {
					this.$message({
						message: '结算失败',
						type: 'error'
					});
				} else if (a == 'success') {
					this.$message({
						message: '结算成功',
						type: 'success'
					});
				}
				this.getTableData();
			},
			complete(row){
				this.see(row)
				// this.curItem = row;
				// this.drawerXimeiComplete_state = true;
			},
			submit_XimeiComplete(){
				this.drawerXimeiComplete_state = false;
				this.getTableData();
			},
			cancel(row){
				this.$confirm('确定取消吗?', '警告', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					let params = {
						"order_id": row.orderNo,
					}
					let loading = this.$loading()
					this.$http.get('api/Order/ReceivedOrder', params).then(res => {
						loading.close()
						if (res.code == 0) {
							this.$message({
								message: '操作成功！',
								type: 'success'
							});
							this.getTableData();
						}
					})
				})
			},
			changePage(num){
				this.page.page=num;
				this.getTableData();
			},
			// 获取列表数据
			getTableData() {
				let curDay = this.$public.FTime(new Date().getTime(),'YYYY-MM-DD')
				let params = {
					"memberId": '',
					"petId":'',
					"status": this.radio,  // 0不限；1进行中；2已完成
					isPay:-1,
					startTime: ('' + (new Date(curDay).getTime()-28800000)).substr(0, 10),  //开始时间
					endTime: ('' + (new Date(curDay).getTime()+86400000-28800000)).substr(0, 10),	//结束时间
					"pageIndex": this.page.page,
					"pageSize": this.page.pageSize,
					"keyword": ""
				}
				let loading = this.$loading()
				this.$http.post('/api/WashBeauty/List', params).then(res => {
					loading.close()
					if (res.code == 0) {
						this.tableData = res.data.data;
						this.page.total = res.data.count;
					}
				})
			},
		}
	}
</script>
<style scoped lang="scss">
.jiedaiOrder{
	width:100%;height: 100%;padding-bottom:50px;box-sizing: border-box;padding-top:40px;position: relative;
	.radioBox{
		padding:12px 30px 12px;position: absolute;z-index: 1;top:0;width:100%;box-sizing: border-box;
	}
	.pageBox{
		// padding:20px;
	}
}
</style>
